import { isConfigObject } from '../../utils';
export const staticTableCellDecorator = (formatter) => ({ cell: { value, }, row: { original, }, }) => {
    if (isConfigObject(value)) {
        const param = value.value;
        return formatter(param, original);
    }
    return formatter(value, original);
};
export const staticTableCellFormatter = staticTableCellDecorator((value) => value);
